(function () {
  var EPS = 4;

  /** One horizontal “page”: distance between slide starts, or full viewport if unknown. */
  function scrollStep(el) {
    var first = el.firstElementChild;
    if (!first) return Math.max(0, el.clientWidth);
    var second = first.nextElementSibling;
    if (second) {
      var stride = second.offsetLeft - first.offsetLeft;
      if (stride > EPS) return stride;
    }
    return el.clientWidth;
  }

  function maxScrollLeft(el) {
    return Math.max(0, el.scrollWidth - el.clientWidth);
  }

  function updateButtons(scroller, prevBtn, nextBtn) {
    var max = maxScrollLeft(scroller);
    var left = scroller.scrollLeft;
    var atStart = left <= EPS;
    var atEnd = max <= EPS || left >= max - EPS;

    prevBtn.classList.toggle('review-scroll-nav__btn--disabled', atStart);
    nextBtn.classList.toggle('review-scroll-nav__btn--disabled', atEnd);
    prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function bindSection(section) {
    if (section.getAttribute('data-review-scroll-nav') === '1') return;

    var scroller = section.querySelector('.review-container-scroll');
    var prevBtn = section.querySelector('.review-scroll-nav__btn--prev');
    var nextBtn = section.querySelector('.review-scroll-nav__btn--next');
    if (!scroller || !prevBtn || !nextBtn) return;

    section.setAttribute('data-review-scroll-nav', '1');

    function onScroll() {
      updateButtons(scroller, prevBtn, nextBtn);
    }

    prevBtn.addEventListener('click', function (e) {
      if (prevBtn.classList.contains('review-scroll-nav__btn--disabled')) return;
      e.preventDefault();
      scroller.scrollBy({ left: -scrollStep(scroller), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function (e) {
      if (nextBtn.classList.contains('review-scroll-nav__btn--disabled')) return;
      e.preventDefault();
      scroller.scrollBy({ left: scrollStep(scroller), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', onScroll, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        requestAnimationFrame(onScroll);
      });
      ro.observe(scroller);
    }

    window.addEventListener('resize', function () {
      requestAnimationFrame(onScroll);
    });

    requestAnimationFrame(onScroll);
    window.setTimeout(onScroll, 400);
  }

  function init() {
    document.querySelectorAll('.shopify-section').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
